import React, { useEffect, useRef, useState } from 'react'
import './Bill.css'
import { useTheme } from '../theme/ThemeContext'
import billlogo from './billing-img/logo_white.png'
import DataTable from 'react-data-table-component'
import logo2 from './billing-img/logo_white.png'
import logo1 from './billing-img/logo_black.png'
import { Flashlight } from 'lucide-react'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const Bill = () => {
  // const backendurl = window.location.hostname === 'localhost'
  //   ? ''
  //   : process.env.REACT_APP_BACKEND_URL;
  const backendurl = window.location.hostname === 'localhost'
  ? ''
  : window.location.hostname === 'demo.ollinwon.com'
    ? process.env.REACT_APP_BACKEND_URL
    : window.location.hostname === 'iot.aizoteq.com'
      ? process.env.REACT_APP_BACKEND_URL2
      : '';
  const token = localStorage.getItem('authToken')


  const { theme } = useTheme()
  const billRef = useRef(null); // Create a ref to the main component
  const [showEstimate, setShowEstimate] = useState(false);
  const [editData, setEditData] = useState(null);
  const [showHistory, setShowHistory] = useState(false);
  const [historydata, setHistoryData] = useState([]);
  const [selectedBill, setSelectedBill] = useState(null);
  const [showInvoice, setShowInvoice] = useState(false);
  const [showSale, setShowSale] = useState(false);
  const [showCustomer, setShowCustomer] = useState(false);
  const [items, setItems] = useState([]);
  const [items2, setItems2] = useState([]);
  const [serialNo, setSerialNo] = useState("");
  const [itemData, setItemData] = useState(null);
  const [paymentpopup, setPaymentPopup] = useState(false);
  const [devices, setDevices] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedModelAttributes, setSelectedModelAttributes] = useState([]);
  const [estimateHistory, setEstimateHistory] = useState(false);
  const [savedBills, setSavedBills] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [balanceInputValue, setBalanceInputValue] = useState("");
  const [paymentRecords, setPaymentRecords] = useState([]);
  const [discountValue, setDiscountValue] = useState("");
  const [userData, setUserData] = useState({});
  const [logo, setLogo] = useState(logo1);
  const [sessionPopup, setSessionPopup] = useState(true)
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(false);
  const [closingPopup, setClosingPopup] = useState(false);
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState("customers");
  const [customerdata, setCustomerData] = useState([]);
  const [filterslide, setFilterslide] = useState(false);
  const [isScanning, setIsScanning] = useState([]);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [HistoryItems, setHistoryItems] = useState([]);
  const [barcode, setBarcode] = useState("");
  const [billingItems, setBillingItems] = useState([]);
  const [scannedBarcodes, setScannedBarcodes] = useState([]);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [cusbillpopup, setCusBillPopup] = useState(false)
  const [billingData, setBillingData] = useState(null);
  const [customerBillPopup, setCustomerBillPopup] = useState(false)
  const [searchTerm, setSearchTerm] = useState("");
  const [customerSelectedBill, setCustomerSelectedBill] = useState(null)
  const [groupedItemsArray, setgroupedItemsArray] = useState([])
  const [balancePayPopup, setBalancePayPopup] = useState(false)
  const [paymentEntries, setPaymentEntries] = useState([]);
  const [balanceamount, setBalance] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState([])
  const [estimateDetails, setEstimateDetails] = useState({
    name: "",
    phone: "",
    email: "",
    address: ""
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [billData, setBillData] = useState({
    serialNo: "",
    items: [],
    type: "",
    customerDetails: {

      name: "",
      phone: "",
      email: "",
      billingAddress: "",
      shippingAddress: "",
      gstin: "",
    },
    paymentRecords: [],  // ✅ Storing payment records
    discountValue: "",
  });

  const handlecustomerBill = (row) => {
    // console.log("Received row:", row);

    if (!row || !row.items) {
      console.error("Error: row or row.items is null/undefined", row);
      return;
    }

    setCustomerSelectedBill(row);

    const groupedItems = row.items.reduce((acc, item) => {
      const key = item.model;
      if (!acc[key]) {
        acc[key] = { ...item, quantity: 1 };
      } else {
        acc[key].quantity += 1;
        acc[key].mrp = parseFloat(acc[key].mrp) + parseFloat(item.mrp);
        acc[key].item_discount = parseFloat(acc[key].item_discount) + parseFloat(item.item_discount);
        acc[key].final_price = parseFloat(acc[key].final_price) + parseFloat(item.final_price);
        acc[key].cgst = parseFloat(acc[key].cgst) + parseFloat(item.cgst);
        acc[key].sgst = parseFloat(acc[key].sgst) + parseFloat(item.sgst);
        acc[key].igst = parseFloat(acc[key].igst) + parseFloat(item.igst);
      }
      return acc;
    }, {});

    setgroupedItemsArray(Object.values(groupedItems));
    setCustomerBillPopup(true);
  };

  const fetchBillingData = async (row) => {
    setBalance(row)
    // console.log("fetchBillingData ", row);

    try {
      const response = await fetch(`${backendurl}/dashboard/api/billing/${filteredData}/${row.id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          // Adjust authentication as needed
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch billing data");
      }

      const result = await response.json();
      // console.log("Fetched Billing Data:", result.data); // Debugging console log
      setBillingData(result.data);
      setCusBillPopup(true)

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };








  useEffect(() => {
    setLogo(theme === 'dark' ? logo2 : logo1);
  }, [theme]);

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible);
  };

  const handleOptionClick = (selectedOption) => {
    setBillData((prevState) => ({
      ...prevState,
      type: selectedOption,  // ✅ Update the type field directly
    }));
    // console.log("type", billData.type);

  };


  useEffect(() => {
    // console.log("Updated BillingItem:", billingItems);
    // console.log("Updated serial no", scannedBarcodes);
    // console.log("Updateddddddd",userData.id);

  }, [billingItems]);

  const handleBarcodeChange = async (e) => {
    const serialNo = e.target.value.trim();
    setBarcode(serialNo);

    if (serialNo.length > 0) {
      try {
        // console.log("Fetching data for:", serialNo);
        const response = await fetch(`${backendurl}/dashboard/billing_items/${serialNo}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          const errorMessage = await response.json();
          setError(errorMessage.message);
          return;
        }

        const data = await response.json();

        if (data && typeof data === "object") {
          setBillingItems((prevItems) => {
            const existingItem = prevItems.find((item) => item.model === data.model);

            if (existingItem) {
              return prevItems.map((item) =>
                item.model === data.model
                  ? {
                    ...item,
                    qty: item.qty + 1,
                    final_price: (parseFloat(item.final_price) + parseFloat(data.final_price)).toFixed(2)
                  }
                  : item
              );
            } else {
              return [...prevItems, { ...data, serialNo, qty: 1 }];
            }
          });

          // ✅ Store barcode in array
          setScannedBarcodes((prevBarcodes) => [...prevBarcodes, serialNo]);

          // ✅ Clear the barcode input field
          setBarcode("");
        }
        setError("");
      } catch (err) {
        setError("Failed to fetch billing item");
        console.error(err);
      }
    }
  };

  const handelReturnReset = () => {
    setBillingItems([])
    setScannedBarcodes([])
  }

  // ✅ Function to remove an item manually
  const handleRemoveItem = (serialNo) => {
    setBillingItems((prevItems) => prevItems.filter((item) => item.serialNo !== serialNo));
    setScannedBarcodes([])
  };

  // console.log("BillingItem",billingItem);


  // useEffect(() => {
  //   if (isScanning) {
  //     // Wait for a short delay (e.g., 500ms) after user stops typing
  //     const timer = setTimeout(() => {
  //       if (billData.serialNo.trim() !== "") {
  //         console.log("Scanned Barcode:", billData.serialNo);

  //         // Process the scanned barcode (fetch item details, update bill, etc.)

  //         // Clear the input field after successful scan
  //         // setBillData({ serialNo: "" });

  //         // Reset scanning state
  //         setIsScanning("");
  //       }
  //     }, 500); // Adjust delay as needed based on scanner speed

  //     return () => clearTimeout(timer); // Cleanup timeout on each change
  //   }
  // }, [billData.serialNo, isScanning]);


  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await fetch(`${backendurl}/api/display/user`, {
        method: "GET",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        credentials: "include",
      });

      if (response.ok) {
        const data = await response.json();
        setUserData(data);
        // console.log("userrrrrr dataaaa", data);


      } else {
        console.error("Failed to fetch user data.");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  // console.log("fetch user dat ",billData.customerDetails.name);




  const handleBillingSubmit = async () => {
    setIsProcessing(true);
    // console.log("billData.customerDetails.email", billData.customerDetails.email);

    const billingData = {
      sessionid: session.id,
      type: billData.type,
      user_id: userData.id,
      name: billData.customerDetails.name,
      address: billData.customerDetails.billingAddress,
      shipping_address: billData.customerDetails.shippingAddress,
      phone: billData.customerDetails.phone,
      alt_phone: billData.customerDetails.phone,
      email: billData.customerDetails.email,
      items: billData.items.flatMap(item =>
        item.serialNos.map(serial_no => ({ serial_no, model: item.model }))
      ),
      discount: parseFloat(discountValue) || 0,
      gstin: billData.customerDetails.gstin || "",
      payment_methods: billData.paymentRecords.map(record => ({
        payment_method: record.method,
        amount: parseFloat(record.amount)
      })),
      billing_createdby: userData.name
    };

    try {
      // console.log("billllllllllll", billingData);

      const response = await fetch(`${backendurl}/dashboard/api/billing/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(billingData)
      });

      const result = await response.json();
      if (response.ok) {
        // alert("Billing Successful");
        // console.log("Billing Response:", result);
        setPaymentPopup(false);
        setBillData({
          serialNo: "",
          items: [],
          type: "",
          customerDetails: {

            name: "",
            phone: "",
            email: "",
            billingAddress: "",
            shippingAddress: "",
            gstin: "",
          },
          paymentRecords: [],  // ✅ Storing payment records
          discountValue: "",
        });
        setDiscountValue('')
        // Check if pdfpath is available and print it
        if (result.pdfpath) {
          const printWindow = window.open(result.pdfpath, "_blank");
          if (printWindow) {
            printWindow.onload = () => {
              printWindow.print();
            };
          }
          // printPDF(result.pdfpath)
        }

      } else {
        alert("Billing Failed: " + result.error);
        console.error("Billing Error:", result);
      }
    } catch (error) {
      console.error("Network Error:", error);
      alert("Network Error. Please try again.");
    }
    setIsProcessing(false);
  };


  const getPdfUrl = (fullPdfUrl) => {
    // Extract only the path from the URL (e.g., /dashboard/receipt/receipt_112.pdf)
    const urlPath = new URL(fullPdfUrl).pathname;

    // Check if running on localhost
    const isLocalhost = window.location.hostname === "localhost";

    // Set base URL based on environment
    const baseUrl = isLocalhost
      ? "http://13.200.215.17:3001"  // Local environment
      : "https://13.200.215.17:3000"; // Production

    return `${baseUrl}${urlPath}`;
  };

  const printPDF = (fullPdfUrl) => {
    const pdfUrl = getPdfUrl(fullPdfUrl);

    let iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0px";
    iframe.style.height = "0px";
    iframe.style.border = "none";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    iframe.onload = () => {
      try {
        iframe.focus();
        iframe.contentWindow.print();
      } catch (error) {
        alert("Printing failed due to security restrictions. Please print manually.");
        console.error("Print Error:", error);
      }

      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 5000);
    };
  };

  useEffect(() => {
    // Save billData to sessionStorage whenever it updates
    sessionStorage.setItem("billData", JSON.stringify(billData));
  }, [billData]);

  // Function to update sessionStorage
  const updateSessionStorage = (newData) => {
    sessionStorage.setItem('billData', JSON.stringify(newData));
  };




  const handleCustomerChange = (e) => {
    const { name, value } = e.target;
    setBillData((prev) => {
      const updatedData = {
        ...prev,
        customerDetails: { ...prev.customerDetails, [name]: value }
      };
      updateSessionStorage(updatedData);
      // console.log("updateingggg data", updatedData);
      // console.log("billlllling data", billData);

      return updatedData;
    });
  };

  const copyBillingToShipping = () => {
    setBillData((prev) => {
      const updatedData = {
        ...prev,
        customerDetails: {
          ...prev.customerDetails,
          shippingAddress: prev.customerDetails.billingAddress // Copying billingAddress
        }
      };
      updateSessionStorage(updatedData);
      return updatedData;
    });
  };


  // Function to handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEstimateDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value
    }));
  };

  const handelEstimateHistory = () => {
    setEstimateHistory(true)
  }


  // ....................................................................... Payment .............................................................................
  const handlePayment = () => {
    setPaymentPopup(true)
  }


  // ..................................................................... Estimate .............................................................................
  const handleEstimate = (row) => {
    setEditData(row);
    setShowEstimate(true);
  };
  const handleCloseEstimate = () => {
    setShowEstimate(false);
    setEditData(null);
  };

  // ..................................................................... History ..............................................................................
  const handleHistory = (row) => {
    setEditData(row);
    setShowHistory(true);
  };
  const handleCloseHistory = () => {
    setShowHistory(false);
    setEditData(null);
  };

  //...................................................................... Invoice ..............................................................................
  const handleInvoice = (row) => {
    // setEditData(row);
    setShowInvoice(true);
  };
  const handleCloseInvoice = () => {
    setShowInvoice(false);
    // setEditData(null);
  };

  // ..................................................................... Sale .................................................................................
  const handleSale = (row) => {
    setEditData(row);
    setShowSale(true);
  };
  const handleCloseSale = () => {
    setShowSale(false);
    setEditData(null);
  };

  // ..................................................................... Customer .............................................................................
  const handleCustomer = (row) => {
    setEditData(row);
    setShowCustomer(true);
  };
  const handleCloseCustomer = () => {
    setShowCustomer(false);
    setEditData(null);
  };

  // .................................................................... Closing ...............................................................................
  // const handleClosing = (row) => {
  //   setEditData(row);
  //   setShowCustomer(true);
  // };
  // const handleCloseClosing = () => {
  //   setShowClosing(false);
  //   setEditData(null);
  // };


  const handlePaymentCancel = () => {
    setPaymentPopup(false)
    setPaymentRecords([])
  }


  useEffect(() => {

    fetchDevices();
  }, []);

  const fetchDevices = async (query = "") => {
    try {
      const response = await fetch(
        `${backendurl}/dashboard/api/display/prices-table?search=${query}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          method: "GET",
        }
      );
      const data = await response.json();
      const formattedData = Array.isArray(data.data) ? data.data : [];
      setDevices(formattedData);
      // generateDynamicColumns(formattedData);
    } catch (error) {
      console.error("Error fetching devices:", error);
    }
  };

  const handleModelSelect = (selectedDevice) => {
    updateItemsTable2(selectedDevice);
    setSelectedModelAttributes(selectedDevice.attributes || []);
    setSearchResults([]);
  }

  // const updateItemsTable = (newItem) => {
  //   setBillData((prev) => {
  //     const existingItem = prev.items.find((item) => item.model === newItem.model);

  //     const updatedItems = existingItem
  //       ? prev.items.map((item) =>
  //           item.model === newItem.model ? { ...item, qty: item.qty + 1 } : item
  //         )
  //       : [...prev.items, { ...newItem, qty: 1 }];

  //     const updatedData = { ...prev, items: updatedItems };
  //     updateSessionStorage(updatedData);
  //     console.log("localll",updatedData)
  //     return updatedData;
  //   });
  // };
  const updateItemsTable = (newItem) => {
    setBillData((prev) => {
      if (!newItem || !newItem.model) return prev; // Prevent invalid items

      const serialNo = newItem.serialNo || newItem.serialno; // Ensure we get the correct key

      const existingItemIndex = prev.items.findIndex((item) => item.model === newItem.model);
      if (existingItemIndex !== -1) {
        const updatedItems = [...prev.items];
        updatedItems[existingItemIndex] = {
          ...updatedItems[existingItemIndex],
          qty: updatedItems[existingItemIndex].qty + 1,
          serialNos: [...updatedItems[existingItemIndex].serialNos, serialNo], // Add correct serialNo
        };

        const updatedData = { ...prev, items: updatedItems };
        updateSessionStorage(updatedData);
        return updatedData;
      } else {
        const updatedItems = [...prev.items, { ...newItem, qty: 1, serialNos: [serialNo] }];
        const updatedData = { ...prev, items: updatedItems };
        updateSessionStorage(updatedData);
        return updatedData;
      }
    });
  };





  const handleSerialNoChange = async (e) => {
    const newSerialNo = e.target.value;
    setIsScanning(newSerialNo)
    setBillData((prev) => {
      const updatedData = { ...prev, serialNo: newSerialNo };
      updateSessionStorage(updatedData);
      return updatedData;
    });

    if (!newSerialNo.trim()) return;

    try {
      // console.log("Fetching item for serial number:", newSerialNo);
      const response = await fetch(`${backendurl}/dashboard/price/${newSerialNo}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      const data = await response.json();
      // console.log("API Response:", response.status, data);

      if (response.ok) {
        updateItemsTable(data);
        // setBillData({ serialNo: "" });
        setIsScanning("");
      } else {
        console.error("Item not found:", data.message);
      }
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };

  const updateItemsTable2 = (newItem) => {
    setItems2((prevItems) => {
      const existingItem = prevItems.find((item) => item.model === newItem.model);

      if (existingItem) {
        return prevItems.map((item) =>
          item.model === newItem.model ? { ...item, qty: item.qty + 1 } : item
        );
      } else {
        return [...prevItems, { ...newItem, qty: 1 }];
      }
    });
  };

  const handleFullScreen = () => {
    if (billRef.current) {
      if (!document.fullscreenElement) {
        billRef.current.requestFullscreen(); // Enter full screen
      } else {
        document.exitFullscreen(); // Exit full screen
      }
    }
  };

  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    // Set up an interval to update the time every second
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);




  // const columns = [
  //   {
  //     name: "No",
  //     selector: (row) => row.no,
  //   },
  //   {
  //     name: "Code",
  //     selector: (row) => row.code,
  //   },
  //   {
  //     name: "Model",
  //     selector: (row) => row.model,
  //   },
  //   {
  //     name: "Qty",
  //     selector: (row) => row.qty,
  //   },
  //   {
  //     name: "Price",
  //     selector: (row) => row.price,
  //   },
  //   {
  //     name: "Discount",
  //     selector: (row) => row.discount,
  //   },
  //   {
  //     name: "Tax",
  //     selector: (row) => row.tax,
  //   },
  //   {
  //     name: "Total",
  //     selector: (row) => row.total,
  //   },
  // ];

  // const data = [
  //   {
  //     no: 1,
  //     code: '254685',
  //     model: "absyejdku",
  //     qty: 2,
  //     price: "₹ 1999.00",
  //     discount: "50",
  //     tax: "5.2",
  //     total: '₹ 2300'
  //   },
  // ];
  useEffect(() => {
    // console.log("searchQuery", searchQuery)

    if (searchQuery.length > 0) {
      fetch(`${backendurl}/dashboard/api/search/model/price?query=${searchQuery}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => response.json())
        .then(data => setSearchResults(data))
        .catch(error => console.error('Error fetching models:', error));
    } else {
      setSearchResults([]);
    }
  }, [searchQuery, backendurl, token]);

  const handleSelectModel = (model) => {
    setSelectedModel(model);
    setSearchQuery(model.model);
    setSearchResults([]); // Hide dropdown after selection
  };
  // console.log("searchQuery",searchQuery)
  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    const tableElement = document.getElementById('bill-estimate-table-main').cloneNode(true);
    const grandTotal = document.getElementById('grand-total').innerHTML;

    // Remove quantity increment/decrement buttons
    tableElement.querySelectorAll(".qty-btn").forEach(btn => btn.remove());

    // Replace input field with just its value
    tableElement.querySelectorAll(".quantity-input").forEach(input => {
      const quantityValue = input.value;
      const span = document.createElement("span");
      span.textContent = quantityValue;
      input.parentNode.replaceChild(span, input);
    });

    // Remove the "Remove" column without affecting "Total"
    tableElement.querySelectorAll("tr").forEach(row => {
      if (row.cells.length === 7) { // If it has 7 columns initially
        row.deleteCell(-1); // Remove last column (Remove)
      }
    });

    const cleanedTableHtml = tableElement.innerHTML;

    printWindow.document.write(`
  <html lang="en">
  <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Quotation</title>
      <style>
          body { font-family: Arial, sans-serif; margin: 20px; background-color: #f9f9f9; }
          .quotation-container { max-width: 900px; margin: auto; background: #fff; padding: 20px; border: 1px solid #ddd; border-radius: 8px; }
          .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #000; padding-bottom: 10px; }
          .header img { width: 150px; height: auto; display: block; margin: 0 auto 10px; }
          .header h2 { margin: 0; }
          .details { margin-top: 20px; display: flex; justify-content: space-between; }
          .details div { width: 48%; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { border: 1px solid #000; padding: 8px; text-align: left; }
          th { background-color: #f2f2f2; }
          .total { text-align: right; font-weight: bold; margin-top: 20px; border: 1px solid #000; padding: 8px; }
          tfoot tr th, tfoot tr td { border: 1px solid #000; padding: 8px; text-align: right; }
      </style>
  </head>
  <body>
      <div class="quotation-container">
          <div class="header">
              <h2>QUOTATION</h2>
          </div>
          <p><strong>AIZO TeQ Solutions Pvt Ltd</strong><br>Room no V3&E, Parammalad PO, Naduvayalparambu, Tirur, Malappuram, Pin 676551<br>Phone: 9188888355<br>Email: info@aizo.in</p>
          
          <div class="details">
              <div>
                  <h4>BILL TO</h4>
                  <p>
                  Name: ${estimateDetails.name}
                  <br>Phone: ${estimateDetails.phone}
                  <br>Email: ${estimateDetails.email}
                  <br>Address: ${estimateDetails.address}
                  </p>
              </div>
              <div>
                  <h4>DATE</h4>
                  <p>${new Date().toLocaleDateString("en-GB")}</p>
              </div>
          </div>
          
          <table>
              <tbody>
                  ${cleanedTableHtml}
              </tbody>
          </table>
          
          <p class="total">GRAND TOTAL: ₹ ${grandTotal}</p>
      </div>

      <script>
          window.onload = function() {
              window.print();
              window.onafterprint = function() { window.close(); };
          };
      </script>
  </body>
  </html>
  `);

    printWindow.document.close();
  };








  // const handleEmailSend = () => {
  //   if (!estimateDetails.email) {
  //     alert("Please enter an email address!");
  //     return;
  //   }

  //   const billTable = document.getElementById("bill-estimate-table-main")?.innerHTML || "No billing table found";

  //   const emailContent = `
  //   <html>
  //     <head>
  //       <style>
  //         table { width: 100%; border-collapse: collapse; }
  //         th, td { border: 1px solid #000; padding: 8px; text-align: left; }
  //         th { background-color: #f2f2f2; }
  //       </style>
  //     </head>
  //     <body>
  //       <h2>Billing Estimate</h2>
  //       <table>${billTable}</table>
  //     </body>
  //   </html>
  // `;

  //   if (window.Email) {
  //     window.Email.send({
  //       SecureToken: "8edc532a-c551-4a15-8f13-3b4ef0942ff8", // Replace with your actual token
  //       To: estimateDetails.email,
  //       From: "anshid8593@gmail.com", // Ensure this email is allowed by SMTP.js
  //       Subject: "Your Billing Estimate",
  //       Body: emailContent
  //     })
  //       .then((message) => {
  //         console.log("SMTP.js response:", message);
  //         alert("Email sent successfully!");
  //       })
  //       .catch((error) => {
  //         console.error("Email send error:", error);
  //         alert("Failed to send email.");
  //       });
  //   } else {
  //     alert("Email service is not available. Please check SMTP.js integration.");
  //   }
  // };



  const handleEmailSend = async () => {
    // console.log("Starting email send...");

    if (!estimateDetails.email) {
      alert("Please enter an email address!");
      return;
    }

    const billTable = document.getElementById("bill-estimate-table-main");

    if (!billTable) {
      alert("No billing table found!");
      console.error("Error: Bill table element not found.");
      return;
    }

    // Extract and clean table HTML
    const cleanedTableHtml = billTable.innerHTML;

    // Calculate Grand Total (example, modify as needed)
    let grandTotal = 0;
    document.querySelectorAll("#bill-estimate-table-main tbody tr").forEach((row) => {
      const priceCell = row.querySelector("td:last-child");
      if (priceCell) {
        grandTotal += parseFloat(priceCell.textContent.replace("₹", "").trim()) || 0;
      }
    });

    // Template for the quotation
    const emailContent = `
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Quotation</title>
        <style>
            body { font-family: Arial, sans-serif; margin: 20px; background-color: #f9f9f9; }
            .quotation-container { max-width: 900px; margin: auto; background: #fff; padding: 20px; border: 1px solid #ddd; border-radius: 8px; }
            .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #000; padding-bottom: 10px; }
            .header h2 { margin: 0; }
            .details { margin-top: 20px; display: flex; justify-content: space-between; }
            .details div { width: 48%; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #000; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
            .total { text-align: right; font-weight: bold; margin-top: 20px; border: 1px solid #000; padding: 8px; }
        </style>
    </head>
    <body>
        <div class="quotation-container">
            <div class="header">
                <h2>QUOTATION</h2>
            </div>
            <p><strong>AIZO TeQ Solutions Pvt Ltd</strong><br>Room no V3&E, Parammalad PO, Naduvayalparambu, Tirur, Malappuram, Pin 676551<br>Phone: 9188888355<br>Email: info@aizo.in</p>
            
            <div class="details">
                <div>
                    <h4>BILL TO</h4>
                    <p>
                    Name: ${estimateDetails.name}
                    <br>Phone: ${estimateDetails.phone}
                    <br>Email: ${estimateDetails.email}
                    <br>Address: ${estimateDetails.address}
                    </p>
                </div>
                <div>
                    <h4>DATE</h4>
                    <p>${new Date().toLocaleDateString("en-GB")}</p>
                </div>
            </div>
            
            <table>
                <tbody>
                    ${cleanedTableHtml}
                </tbody>
            </table>
            
            <p class="total">GRAND TOTAL: ₹ ${grandTotal}</p>
        </div>
    </body>
    </html>
    `;

    try {
      // console.log("Generating PDF from template...");

      // Create a temporary div to hold the HTML content
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = emailContent;
      document.body.appendChild(tempDiv);

      // Convert to canvas
      const canvas = await html2canvas(tempDiv);
      document.body.removeChild(tempDiv); // Cleanup

      // Generate PDF
      const pdf = new jsPDF("p", "mm", "a4");
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);

      // Convert PDF to Blob
      const pdfBlob = pdf.output("blob");
      // console.log("PDF generated successfully", pdfBlob);

      // Prepare form data
      const formData = new FormData();
      formData.append("pdf", pdfBlob, "quotation.pdf");
      formData.append("email", estimateDetails.email);

      // console.log("Sending email request to backend...");

      // Send the email
      const response = await fetch(`${backendurl}/dashboard/estimate/send-email`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      // console.log("Response from server:", result);

      if (response.ok) {
        alert("Email sent successfully!");
      } else {
        alert("Failed to send email: " + result.error);
      }
    } catch (error) {
      console.error("Email send error:", error);
      alert("Error sending email.");
    }
  };


  const handleSave = () => {
    // console.log("Saving items:", items2);

    // Retrieve existing bills from localStorage (or start with an empty array)
    const existingBills = JSON.parse(localStorage.getItem("savedBills")) || [];

    // Create new bill object
    const billData = {
      customer: estimateDetails,
      items: items2,
      total: items2.reduce((sum, item) => sum + ((item.mrp - ((item.discount || 0) / 100) * item.mrp) * item.qty), 0).toFixed(2),
      date: new Date().toISOString(),
    };

    // Append new bill to existing bills
    existingBills.push(billData);

    // Save updated bill list back to localStorage
    localStorage.setItem("savedBills", JSON.stringify(existingBills));

    alert("Bill saved successfully!");
    // console.log("Updated savedBills:", existingBills);
    loadSavedBills()

  };


  useEffect(() => {
    loadSavedBills();
  }, []);

  // Load saved bills from localStorage
  const loadSavedBills = () => {
    const storedBills = JSON.parse(localStorage.getItem("savedBills")) || [];
    setSavedBills(storedBills);

  };


  const handleDeleteBill = (index) => {
    const updatedBills = savedBills.filter((_, i) => i !== index);
    localStorage.setItem("savedBills", JSON.stringify(updatedBills));
    setSavedBills(updatedBills);
  };

  const handleViewBill = (bill) => {
    setEstimateDetails(bill.customer); // Load customer details
    setItems2(bill.items); // Load bill items
    setShowEstimate(true); // Show the estimate popup
    setEstimateHistory(false); // Close history popup
  };

  const handleButtonClick = (value) => {
    if (value === "C") {
      setInputValue(""); // Clear the input field
    } else {
      setInputValue((prev) => prev + value); // Append clicked value
    }
  };
  const handleBalanceButtonClick = (value) => {
    if (value === "C") {
      setBalanceInputValue(""); // Clear the input field
    } else {
      setBalanceInputValue((prev) => prev + value); // Append clicked value
    }
  };

  const handlePaymentMethodClick = (method) => {
    if (!inputValue.trim()) {
      alert("Please enter an amount before selecting a payment method.");
      return;
    }

    // Create new payment record
    const newPayment = { method, amount: parseFloat(inputValue).toFixed(2) };

    // Update UI immediately
    setPaymentRecords((prev) => [...prev, newPayment]);

    // Update session storage and state
    setBillData((prev) => {
      const updatedData = {
        ...prev,
        paymentRecords: [...prev.paymentRecords, newPayment],
      };
      updateSessionStorage(updatedData);
      return updatedData;
    });

    // Reset input field
    setInputValue("");
  };


  const handleBalancePaymentMethodClick = (method) => {
    if (balanceInputValue.trim() === "" || isNaN(balanceInputValue)) return; // Prevent empty values

    const newEntry = { method, amount: parseFloat(balanceInputValue) };

    setPaymentEntries((prevEntries) => [...prevEntries, newEntry]); // Add new entry
    setBalanceInputValue(""); // Clear input after adding
  };



  const handleDiscountChange = (e) => {
    let value = e.target.value;
    if (!isNaN(value) && value >= 0) {
      setDiscountValue(value);
    }
  };

  // Calculate invoice value
  const invoiceValue = billData.items.reduce((sum, item) => {
    const discount = (item.discount / 100) * item.mrp * item.qty;
    const taxableValue = (item.mrp * item.qty) - discount;
    const totalTaxRate = parseFloat(item.cgst || 0) + parseFloat(item.sgst || 0) + parseFloat(item.igst || 0);
    const tax = taxableValue * (totalTaxRate / 100);
    return sum + (taxableValue + tax);
  }, 0);


  // Calculate total collected amount
  const collectedAmount = paymentRecords.reduce(
    (sum, record) => sum + parseFloat(record.amount),
    0
  );

  // Calculate discount amount
  const discountAmount = (invoiceValue * (parseFloat(discountValue) || 0)) / 100;

  // Calculate balance
  const balanceAmount = (invoiceValue - discountAmount - collectedAmount).toFixed(2);

  const handleIncreaseQty = (index) => {
    const updatedItems = [...items2];
    updatedItems[index].qty += 1;
    setItems2(updatedItems);
  };

  // Decrease quantity
  const handleDecreaseQty = (index) => {
    if (items2[index].qty > 1) {
      const updatedItems = [...items2];
      updatedItems[index].qty -= 1;
      setItems2(updatedItems);
    }
  };

  const handleCancelEstimate = () => {
    setItems2([])
    setEstimateDetails({
      name: "",
      phone: "",
      email: "",
      address: ""
    });
    setSelectedModelAttributes([])
  }

  const handleRemoveRow = (index) => {
    const updatedItems = items2.filter((_, i) => i !== index);
    setItems2(updatedItems);
  };


  // const handleDeleteSerialNo = (index, serialNo) => {
  //   setBillData((prev) => {
  //     const updatedItems = prev.items.map((item, i) => {
  //       if (i === index) {
  //         const filteredSerialNos = item.serialNos.filter((sn) => sn !== serialNo);
  //         return { ...item, qty: filteredSerialNos.length, serialNos: filteredSerialNos };
  //       }
  //       return item;
  //     }).filter((item) => item.qty > 0);

  //     const updatedData = { ...prev, items: updatedItems };
  //     console.log("serialno",updatedData)
  //     updateSessionStorage(updatedData);
  //     return updatedData;
  //   });
  // };
  const handleDeleteSerialNo = (index, serialNo) => {
    // console.log(" handleDeleteSerialNoworking", serialNo)
    setBillData((prev) => {
      if (!prev?.items?.length) return prev; // Ensure safety

      const updatedItems = prev.items
        .map((item, i) => {
          if (i === index) {
            // Remove the selected serial number
            const filteredSerialNos = item.serialNos.filter((sn) => sn !== serialNo);

            // If no serial numbers are left, return `null` to remove the item
            if (filteredSerialNos.length === 0) {
              return null;
            }

            // Otherwise, update the item
            return { ...item, qty: filteredSerialNos.length, serialNos: filteredSerialNos };
          }
          return item;
        })
        .filter((item) => item !== null); // Remove items that have no serial numbers left

      const updatedData = { ...prev, items: updatedItems };
      updateSessionStorage(updatedData);
      return updatedData;
    });
  };




  const groupItemsByModel = (items) => {
    return items.reduce((acc, item) => {
      const existingItem = acc.find((i) => i.model === item.model);

      if (existingItem) {
        existingItem.qty += item.qty;
        existingItem.mrp += item.mrp;
        existingItem.discount += item.discount;
        existingItem.taxableValue += item.taxableValue;
        existingItem.tax += item.tax;
        existingItem.total += item.total;
        existingItem.serialNos = [...existingItem.serialNos, ...item.serialNos]; // Combine serial numbers
      } else {
        acc.push({ ...item, serialno: [...item.serialno] });
      }

      return acc;
    }, []);
  };

  const groupedItems = groupItemsByModel(billData.items);

  useEffect(() => {
    const savedSession = localStorage.getItem("billingSession");
    if (savedSession) {
      setSession(JSON.parse(savedSession));

    }
    // console.log('billing1', savedSession);
  }, []);


  const openSession = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${backendurl}/dashboard/open-session`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ opened_by: "admin" }), // Change accordingly
      });

      const data = await response.json();
      // console.log("session id", data);

      if (response.ok) {
        setSession(data.session);
        localStorage.setItem("billingSession", JSON.stringify(data.session)); // Store session in localStorage
        alert("Session Opened Successfully!");
      } else {
        alert(`Error: ${data.error}`);
      }
    } catch (error) {
      alert("Failed to open session");
    } finally {
      setLoading(false);
    }
  };


  const closeSession = async () => {
    const savedSession = localStorage.getItem("billingSession");
    if (!savedSession) {
      alert("No active session found!");
      return;
    }

    const session = JSON.parse(savedSession);
    const session_id = session.id; // Extract session ID from localStorage

    setLoading(true);
    try {
      const response = await fetch(`${backendurl}/dashboard/close-session`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ session_id, closed_by: "admin" }), // Change accordingly
      });

      const data = await response.json();
      if (response.ok) {
        localStorage.removeItem("billingSession"); // Remove session from localStorage
        // alert("Session closed successfully!");
        setClosingPopup(false);
        setSessionPopup(true)
      } else {
        alert(`Error: ${data.error}`);
      }
    } catch (error) {
      alert("Failed to close session");
    } finally {
      setLoading(false);
    }
  };

  const handleHistoryBils = (row) => {
    setSelectedBill(row);
    // console.log("historyy row", row);
    setPaymentDetails(row)
    groupItemsHistory(row);
  }

  const his = [
    { name: "ID", selector: (row, index) => index + 1, sortable: true },
    { name: "Invoice No", selector: (row) => row.receipt_no, sortable: true },
    { name: "Name", selector: (row) => row.customer_name, sortable: true },
    { name: "Phone", selector: (row) => row.phone },
    { name: "Amount", selector: (row) => row.total_amount },
    {
      name: "Action",
      cell: (row) => (
        <div className="bill-history-action">
          {/* {console.log("historyy row" , row)} */}

          <button className="view-button" onClick={() => handleHistoryBils(row)}>View Details</button>

          {/* {console.log("setSelectedBill",selectedBill)} */}

        </div>
      ),
    },
  ];

  const customerBill = [
    { name: "ID", selector: (row, index) => index + 1, sortable: true },
    { name: "Invoice No", selector: (row) => row.receipt_no || "-", sortable: true },
    { name: "Name", selector: (row) => row.entity_name || "-", sortable: true },
    { name: "Total Amount", selector: (row) => row.payable_amount || "-", sortable: true },
    { name: "Paid Amount", selector: (row) => row.paid_amount || "-", sortable: true },
    { name: "Balnce", selector: (row) => row.balance || "-", sortable: true },
    {
      name: "Date",
      selector: (row) => row.receipt_date ? row.receipt_date.split("T")[0] : "-",
      sortable: true,
    },

    {
      name: "Action",
      cell: (row) => (
        <div className="bill-history-action">
          {/* {console.log("historyy row" , row)} */}

          <button className="view-button" onClick={() => handlecustomerBill(row)} >View Details</button>

          {/* {console.log("setSelectedBill",selectedBill)} */}

        </div>
      ),
    },
  ]

  // Dummy data
  const data = [
    { name: "John Doe", address: "abcd", phone: 7821694112, altphone: "1234567890", totalamount: 45, balance: 2540, email: "sdabeb@gmail.com", paidamount: 1236, reamount: 844, addedby: "advDv" },
    { name: "John Doe", address: "abcd", phone: 7821694112, altphone: "1234567890", totalamount: 45, balance: 2540, email: "sdabeb@gmail.com", paidamount: 1236, reamount: 844, addedby: "advDv" },
    { name: "John Doe", address: "abcd", phone: 7821694112, altphone: "1234567890", totalamount: 45, balance: 2540, email: "sdabeb@gmail.com", paidamount: 1236, reamount: 844, addedby: "advDv" },
  ];


  useEffect(() => {
    const fetchBillingHistory = async () => {
      try {
        const response = await fetch(`${backendurl}/dashboard/api/recent-bills`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },

        });
        const result = await response.json();
        setHistoryData(result);
        // console.log("resultsss", result);

      } catch (error) {
        console.error("Error fetching billing history:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBillingHistory();
  }, []);

  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-GB");


  const customercol = [
    { name: "ID", selector: (row, index) => index + 1, sortable: true },
    { name: "Name", selector: (row) => row.name || "-", sortable: true },
    { name: "Address", selector: (row) => row.address || "-", sortable: true },
    { name: "Phone", selector: (row) => row.phone || "-", sortable: true },
    { name: "Alt Phone", selector: (row) => row.alt_phone || "-", sortable: true },
    { name: "Total Amount", selector: (row) => row.total_amount || "-", sortable: true },
    { name: "Balance", selector: (row) => row.balance || "-", sortable: true },
    { name: "Email", selector: (row) => row.email || "-", sortable: true },
    { name: "Paid Amount", selector: (row) => row.paid_amount || "-", sortable: true },
    {
      name: "Refund Amount", selector: (row) => row.refund_amount || "-", sortable: true
    },
    { name: "Added By", selector: (row) => row.addedby || "-", sortable: true },
    {
      name: "Action",
      cell: (row) => (
        <div className="bill-history-action">

          <button className="view-button1" onClick={() => fetchBillingData(row)}> <i class="fa-solid fa-receipt"></i> </button>

          {/* {console.log("setSelectedBill",selectedBill)} */}

        </div>
      ),
    },
  ];




  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!search.trim() && search.length > 0) return; // Prevent API call for empty spaces

        let endpoint = `${backendurl}/dashboard/api/display/party/customers?query=${search}`;
        if (filteredData === "online customers") {
          endpoint = `${backendurl}/dashboard/api/display/party/onlinecustomer?query=${search}`;
        } else if (filteredData === "dealers") {
          endpoint = `${backendurl}/dashboard/api/display/party/dealers?query=${search}`;
        }

        const options = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        const response = await fetch(endpoint, options);
        if (!response.ok) throw new Error("Failed to fetch data");
        const result = await response.json();
        setCustomerData(result.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const delaySearch = setTimeout(() => {
      fetchData();
    }, 500); // Debounce API calls

    return () => clearTimeout(delaySearch);
  }, [search, filteredData]); // Ensure correct dependency


  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSlide = () => {
    setFilterslide((prev) => !prev);
  };
  const handleFilterChange = (filter) => {
    setFilteredData(filter);
    setFilterslide(false); // Close the slide menu after selection
  };

  useEffect(() => {
    const handleBarcodeScan = (event) => {
      if (event.key === "Enter") {
        // console.log("Scanned Barcode:", billData.serialNo);
        // You can process the scanned barcode here (e.g., fetch item details)
      }
    };

    window.addEventListener("keydown", handleBarcodeScan);
    return () => {
      window.removeEventListener("keydown", handleBarcodeScan);
    };
  }, [billData.serialNo]);


  const groupItemsHistory = (selectedBills) => {
    if (!selectedBills?.items) {
      // console.log("selectedBillssssss", selectedBills);

      console.error("No items found in selectedBill");
      return;
    }

    const grouped = selectedBills.items.reduce((acc, item) => {
      if (!acc[item.model]) {
        acc[item.model] = {
          model: item.model,
          qty: 0,
          total_mrp: 0,
          total_discount: 0,
          taxable_value: 0,
          total_tax: 0,
          total_final_price: 0
        };
      }

      const quantity = item.qty ?? 1; // Default to 1 if undefined

      acc[item.model].qty += quantity;
      acc[item.model].total_mrp += item.mrp * quantity;
      acc[item.model].total_discount += item.item_discount * quantity;
      acc[item.model].taxable_value += (item.mrp - item.item_discount) * quantity;
      acc[item.model].total_tax += (item.cgst + item.sgst + item.igst) * quantity;
      acc[item.model].total_final_price += item.final_price * quantity;

      return acc;
    }, {});

    setHistoryItems(Object.values(grouped)); // Convert object to array for rendering
    // console.log("history itemsssss", paymentDetails);
  };

  const handleReturn = async () => {
    setLoading(true);

    const requestBody = {
      serial_numbers: scannedBarcodes, // Replace with actual serial numbers
      userid: userData.id, // Replace with actual user ID
    };

    try {
      const response = await fetch(`${backendurl}/dashboard/api/billing/return/returned`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (response.ok) {
        alert(`Success: ${data.message}\nReceipt No: ${data.receipt_no}`);
        // console.log("return data", data);
        if (data.pdfpath) {
          const printWindow = window.open(data.pdfpath, "_blank");
          if (printWindow) {
            printWindow.onload = () => {
              printWindow.print();
            };
          }
          // printPDF(result.pdfpath)
        }
        billingItems([])

      } else {
        alert(`Error: ${data.error}`);
      }
    } catch (error) {
      alert("Network error. Please try again.");
    }

    setLoading(false);
  };

  // Sum of all collected amounts from table
  const balancecollectedAmount = paymentEntries.reduce((sum, entry) => sum + entry.amount, 0).toFixed(2);

  // Balance Calculation: Balance Value - Collected Amount
  const balance = data
    ? (parseFloat(balanceamount.balance || 0) - parseFloat(balancecollectedAmount)).toFixed(2)
    : "0.00";

  const handleBalancePayment = async () => {
    setLoading(true);
    setMessage("");

    const requestData = {
      id: balanceamount.id, // Replace with actual customer/dealer ID
      type: filteredData, // 'customer', 'dealer', or 'online_customer'
      payments: billingData.payments.map(({ payment_method, payment_amount }) => ({
        method: payment_method,
        amount: parseFloat(payment_amount), // Convert to number if needed
      })),
      created_by: userData.userrole, // Replace with actual user ID
    };

    try {
      const response = await fetch(`${backendurl}/dashboard/api/pay-balance`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(`Payment successful! Receipt ID: ${data.receiptId}`);
      } else {
        setMessage(`Error: ${data.error}`);
      }
    } catch (error) {
      setMessage("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleBalanceCancel = () => {
    setBalancePayPopup(false)
    setPaymentEntries([])
  }

  return (
    <div ref={billRef} className={`bill-main ${theme}-theme`}>
      {sessionPopup && (
        <div className="bill-session-popup-overlay">
          <div className="bill-session-popup-content">
            <h3>Start New Billing Session</h3>
            <button onClick={openSession} disabled={loading || session}>
              {loading ? "Opening..." : session ? setSessionPopup(false) : "ON"}
            </button>
            {session && <p>Session ID: {session.id}</p>}
          </div>
        </div>
      )}
      <div className="bill-dummy">
        <img src={logo} alt="" />
        <div className='bill-time'>
          <p>{currentTime.toLocaleTimeString()}</p>
        </div>
      </div>
      <div className="bill-content-main">
        <div className="bill-content">
          <div className="bill-content-details">
            <div className="bill-customer-details">
              <div className="bill-customer-content">
                <p>Name :</p>
                <input type="text" name="name" value={billData.customerDetails.name} onChange={handleCustomerChange} />
              </div>
              <div className="bill-customer-content">
                <p>Phone :</p>
                <input type="text" name="phone" value={billData.customerDetails.phone} onChange={handleCustomerChange} />
              </div>
              <div className="bill-customer-content">
                <p>Email :</p>
                <input type="text" name="email" value={billData.customerDetails.email} onChange={handleCustomerChange} />
              </div>

              <div className="bill-customer-content">
                <p>GSTIN :</p>
                <input type="text" name="gstin" value={billData.customerDetails.gstin} onChange={handleCustomerChange} />
              </div>
            </div>
            <div className="bill-item-details-main">
              <div className="bill-item-details">
                <div className="bill-customer-content">
                  <p>Scan Barcode :</p>
                  <input type="text" value={isScanning} onChange={handleSerialNoChange} autoFocus />
                </div>
                {/* <div className="bill-customer-content">
                  <p>Item Description :</p>
                  <div className="bill-model-description">

                  </div>
                </div>
                <div className="bill-customer-content">
                  <p>Search :</p>
                  <input type="text" />
                </div> */}
                <div className="bill-customer-content">
                  <p>Billing Address :</p>
                  <div className='billing-address'>
                    <input
                      className='billin-address-input'
                      type="text"
                      name="billingAddress"
                      value={billData.customerDetails.billingAddress}
                      onChange={handleCustomerChange}
                    />
                    <button onClick={copyBillingToShipping}>
                      <i className="fa-solid fa-copy"></i>
                    </button>
                  </div>
                </div>
                <div className="bill-customer-content">
                  <p>Shipping Address :</p>
                  <input
                    type="text"
                    name="shippingAddress"
                    value={billData.customerDetails.shippingAddress}
                    onChange={handleCustomerChange}
                  />
                </div>
              </div>
            </div>

          </div>
          <div className="bill-content-table">
            <table>
              <thead>
                <tr>
                  <th>No</th>
                  <th>Model</th>
                  <th>Qty</th>
                  <th>MRP</th>
                  {/* <th>Retail Price</th> */}
                  <th>Discount</th>
                  <th>Taxable Value</th>
                  <th>Tax</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {billData.items.map((item, index) => {
                  const discount = ((item.discount || 0) / 100) * item.mrp * item.qty;
                  const taxableValue = (item.mrp * item.qty) - discount;
                  const tax =
                    ((parseFloat(item.cgst || 0) +
                      parseFloat(item.sgst || 0) +
                      parseFloat(item.igst || 0)) /
                      100) *
                    taxableValue;
                  const total =
                    taxableValue * (1 + (parseFloat(item.cgst || 0) + parseFloat(item.sgst || 0) + parseFloat(item.igst || 0)) / 100);

                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.model}</td>
                      {/* <td>{item.qty}</td> */}
                      <td>
                        <span onClick={() => setSelectedRow(selectedRow === index ? null : index)} style={{ cursor: 'pointer' }}>
                          {item.qty}
                        </span>
                        {selectedRow === index && (
                          // <select  style={{ cursor: 'pointer' }} onChange={(e) => handleDeleteSerialNo(index, e.target.value)}>
                          //   {/* {console.log("item serialNos",item)} */}
                          //   <option value="" disabled>Select Serial No</option>
                          //   {item.serialNos.map((sn, i) => (
                          //     <option key={i} value={sn}>{sn}</option>
                          //   ))}
                          // </select>
                          <select
                            style={{ cursor: 'pointer' }}
                            onChange={(e) => {
                              handleDeleteSerialNo(index, e.target.value);
                              e.target.value = ""; // Reset the selection to prevent flickering
                            }}
                            onBlur={(e) => e.target.value = ""} // Ensures dropdown closes after selection
                          >
                            <option value=" " disabled>Select Serial No</option>
                            {item.serialNos.map((sn, i) => (
                              <option key={i} value={sn}>{sn}</option>
                            ))}
                          </select>
                        )}
                      </td>
                      <td>₹ {item.mrp}</td>
                      <td>₹ {discount.toFixed(2)}</td>
                      <td>₹ {taxableValue.toFixed(2)}</td>
                      <td>₹ {tax.toFixed(2)}</td>
                      <td>₹ {total.toFixed(2)}</td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan="5">Total</th>

                  {/* Total Taxable Value (MRP - Discount) */}
                  <th>₹ {billData.items.reduce((sum, item) => {
                    const discount = (item.discount / 100) * item.mrp * item.qty;
                    const taxableValue = (item.mrp * item.qty) - discount;
                    return sum + taxableValue;
                  }, 0).toFixed(2)}
                  </th>

                  {/* Total Tax (CGST + SGST + IGST) */}
                  <th>₹ {billData.items.reduce((sum, item) => {
                    const discount = (item.discount / 100) * item.mrp * item.qty;
                    const taxableValue = (item.mrp * item.qty) - discount;
                    const totalTaxRate = parseFloat(item.cgst || 0) + parseFloat(item.sgst || 0) + parseFloat(item.igst || 0);
                    const tax = taxableValue * (totalTaxRate / 100);
                    return sum + tax;
                  }, 0).toFixed(2)}</th>

                  {/* Final Grand Total (Taxable Value + Tax) */}
                  <th>₹ {billData.items.reduce((sum, item) => {
                    const discount = (item.discount / 100) * item.mrp * item.qty;
                    const taxableValue = (item.mrp * item.qty) - discount;
                    const totalTaxRate = parseFloat(item.cgst || 0) + parseFloat(item.sgst || 0) + parseFloat(item.igst || 0);
                    const tax = taxableValue * (totalTaxRate / 100);
                    return sum + (taxableValue + tax);
                  }, 0).toFixed(2)}</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div className="bill-content-payment">
          <div className="bill-content-payment-scroll">
            <div className="bill-payment-nav">
              <i class="fa-solid fa-expand" onClick={handleFullScreen}></i>
            </div>
            <div className="bill-invoice-main">
              <div className="bill-invoice-head">
                <p>Invoice</p>
              </div>
              <div className="bill-invoice-content">
                <p>Sub Total :</p>
                <p>₹ {billData.items.reduce((sum, item) => {
                  const discount = (item.discount / 100) * item.mrp * item.qty;
                  const taxableValue = (item.mrp * item.qty) - discount;
                  return sum + taxableValue;
                }, 0).toFixed(2)}</p>
              </div>

              <div className="bill-invoice-content1">
                <p>Tax :</p>
                <div className="bill-invoice-content1-input">
                  <p>₹ {billData.items.reduce((sum, item) => {
                    const discount = (item.discount / 100) * item.mrp * item.qty;
                    const taxableValue = (item.mrp * item.qty) - discount;
                    const totalTaxRate = parseFloat(item.cgst || 0) + parseFloat(item.sgst || 0) + parseFloat(item.igst || 0);
                    const tax = taxableValue * (totalTaxRate / 100);
                    return sum + tax;
                  }, 0).toFixed(2)}</p>
                </div>

              </div>
              <div className="bill-invoice-content1">
                {/* <p>Discount :</p>
                <div className="bill-invoice-content1-input">
                  <p>₹ {billData.items.reduce((sum, item) => sum + (item.discount || 0) * item.qty, 0).toFixed(2)}</p>
                </div> */}
                <div className="bill-payment-invoice-value">
                  <p>Discount (%):</p>
                  <div className="bill-payment-amount-input">
                    <input
                      type="text"
                      value={discountValue}
                      onChange={handleDiscountChange}
                      placeholder="Enter %"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="bill-net-main">
              <p>Total Net :</p>
              <span>₹ {(invoiceValue - discountAmount).toFixed(2)}</span>
            </div>
            {/* <div className="bill-paid-balance">
              <div className="bill-invoice-content">
                <p>Round of :</p>
                <input type="text" />
              </div>
              <div className="bill-invoice-content">
                <p>Round of :</p>
                <input type="text" />
              </div>
            </div> */}
            <div className="bill-payment-paybtn" >
              <button onClick={handlePayment}>
                Pay Now
              </button>
            </div>
            <div className="bill-payment-buttons">

              {/* ......................................................................... Payment ....................................................................... */}
              {paymentpopup && (
                <div className="bill-popup-overlay">
                  <div className="bill-popup-content">
                    <button className="bill-popup-close" onClick={() => setPaymentPopup(false)}>
                      <i className="fa-solid fa-x"></i>
                    </button>
                    <div className="bill-payment-main">
                      <div className="bill-payment-calculate-main">
                        <div className="bill-payment-calculate">
                          <input type="num   ber" value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
                          <div className="bill-payment-calculate-btn-main">
                            {[
                              ["7", "8", "9"],
                              ["4", "5", "6"],
                              ["1", "2", "3"],
                              ["0", ".", "C"],
                            ].map((row, rowIndex) => (
                              <div className="bill-payment-calculate-btn" key={rowIndex}>
                                {row.map((btnValue) => (
                                  <input
                                    key={btnValue}
                                    type="button"
                                    value={btnValue}
                                    className={btnValue === "C" ? "clear" : ""}
                                    onClick={() => handleButtonClick(btnValue)}
                                  />
                                ))}
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="bill-payment-method-main">
                          <div style={{ backgroundColor: "#E5E7EB", padding: "1rem", borderRadius: "0.375rem", cursor: "pointer" }}>
                            <button
                              onClick={() => handleOptionClick("customers")}
                              style={{
                                padding: "0.5rem 1rem",
                                borderRadius: "0.375rem",
                                backgroundColor: billData.type === "customers" ? "red" : "gray",
                                color: "white",
                                border: "none",
                                marginRight: "0.5rem",
                              }}
                            >
                              Customer
                            </button>
                            <button
                              onClick={() => handleOptionClick("dealers")}
                              style={{
                                padding: "0.5rem 1rem",
                                borderRadius: "0.375rem",
                                backgroundColor: billData.type === "dealers" ? "red" : "gray",
                                color: "white",
                                border: "none",
                              }}
                            >
                              Dealer
                            </button>
                          </div>

                          <div className="bill-payment-method-box" onClick={() => handlePaymentMethodClick("cash")}>
                            <h2>CASH</h2>
                          </div>
                          <div className="bill-payment-method-box" onClick={() => handlePaymentMethodClick("bank")}>
                            <h2>BANK</h2>
                          </div>
                          <div className="bill-payment-method-box" onClick={() => handlePaymentMethodClick("online")}>
                            <h2>GOOGLE PAY</h2>
                          </div>
                        </div>
                      </div>
                      <div className="bill-payment-method-table-main">
                        <div className="bill-payment-table-div">
                          <table>
                            <thead>
                              <tr>
                                <th>Description</th>
                                <th>Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {paymentRecords.map((record, index) => (
                                <tr key={index}>
                                  <td>{record.method}</td>
                                  <td>₹ {record.amount}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <div className="bill-payment-amount-calculate">
                          <div className="bill-payment-invoice-value">
                            <p>Invoice Value :</p>
                            <div className="bill-payment-amount-box">
                              <span>₹ {(invoiceValue - discountAmount).toFixed(2)}</span>
                            </div>
                          </div>
                          <div className="bill-payment-invoice-value">
                            <p>Collected :</p>
                            <div className="bill-payment-amount-box-1">
                              <p>₹ {collectedAmount.toFixed(2)}</p>
                            </div>
                          </div>
                          {/* <div className="bill-payment-invoice-value">
                            <p>Discount (%):</p>
                            <div className="bill-payment-amount-input">
                              <input
                                type="text"
                                value={discountValue}
                                onChange={handleDiscountChange}
                                placeholder="Enter %"
                              />
                            </div>
                          </div> */}
                          {/* <div className="bill-payment-invoice-value">
                            <p>Discount Amount:</p>
                            <div className="bill-payment-amount-box">
                              <p>₹ {discountAmount.toFixed(2)}</p>
                            </div>
                          </div> */}
                          <div className="bill-payment-invoice-value">
                            <p>Balance :</p>
                            <div className="bill-payment-amount-box-2">
                              <p>₹ {balanceAmount}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bill-payment-save-buttons">
                      <button onClick={handleBillingSubmit} disabled={isProcessing}>
                        {isProcessing ? "Processing..." : "Accept"}
                      </button>
                      <button onClick={handlePaymentCancel}>Cancel</button>
                      <button onClick={() => setPaymentRecords([])}>Reset</button>
                    </div>
                  </div>
                </div>
              )}
              {/* ......................................................................... Estimate ...................................................................... */}
              <div className="bill-payment-button-box" onClick={() => handleEstimate()}>
                <p>Print Estimate</p>
              </div>
              {showEstimate && (
                <div className="bill-popup-overlay">
                  <div className="bill-popup-estimate-content">
                    <button className="bill-popup-close" onClick={handleCloseEstimate}>
                      <i className="fa-solid fa-x"></i>
                    </button>
                    <div className="bill-estimate-address-main">
                      <div className="bill-estimate-address-input">
                        <label htmlFor="name">Name </label>
                        <input
                          type="text"
                          name="name"
                          value={estimateDetails.name}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="bill-estimate-address-input">
                        <label htmlFor="phone">Phone </label>
                        <input
                          type="text"
                          name="phone"
                          value={estimateDetails.phone}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="bill-estimate-address-input">
                        <label htmlFor="email">Email </label>
                        <input
                          type="text"
                          name="email"
                          value={estimateDetails.email}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="bill-estimate-address-input">
                        <label htmlFor="address">Address </label>
                        <input
                          type="text"
                          name="address"
                          value={estimateDetails.address}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="bill-estimate-model-main">
                      <div className="bill-estimate-model">
                        {devices.map((device, index) => (
                          <button
                            key={index}
                            className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
                            onClick={() => handleModelSelect(device)}
                          >
                            {device.model}
                          </button>
                        ))}

                      </div>
                      <div className="bill-estimate-model-description">
                        <h4>Model Attributes</h4>
                        {selectedModelAttributes.length > 0 ? (
                          selectedModelAttributes.map((attr, index) => (
                            <p key={index}>{attr.attributeName} : {attr.attributeValue}</p>
                          ))
                        ) : (
                          <p>No attributes available</p>
                        )}
                      </div>
                      <div className="bill-estimate-model-search">
                        <i className="fa-solid fa-magnifying-glass"></i>
                        <input
                          type="search"
                          placeholder="Search model..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        {searchResults.length > 0 && (
                          <ul className="search-dropdown">
                            {searchResults.map((model, index) => (
                              <li key={index} onClick={() => handleModelSelect(model)}>
                                {model.model}
                              </li>
                            ))}
                          </ul>
                        )}
                        {selectedModel && (
                          <div className="bill-estimate-model-details">
                            <h4>Selected Model: {selectedModel.model}</h4>
                            <p>MRP: ₹{selectedModel.mrp}</p>
                            <p>Retail Price: ₹{selectedModel.retail_price}</p>
                            <p>Warranty: {selectedModel.warranty_period} months</p>
                          </div>
                        )}
                      </div>
                    </div>

                    <div id="bill-estimate-table-main" className="bill-estimate-table-main">
                      <table>
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>Model</th>
                            <th>Qty</th>
                            <th>MRP</th>
                            {/* <th>Retail Price</th> */}
                            <th>Discount</th>
                            <th>Total</th>
                            <th>Remove</th>

                          </tr>
                        </thead>
                        <tbody>
                          {items2.map((item, index) => {
                            const discountAmount = ((item.discount || 0) / 100) * item.mrp;
                            const total = (item.mrp - discountAmount) * item.qty;
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.model}</td>
                                <td>
                                  <button className="qty-btn" onClick={() => handleDecreaseQty(index)}>-</button>
                                  <input className='quantity-input' type="number" value={item.qty} readOnly />
                                  <button className="qty-btn" onClick={() => handleIncreaseQty(index)}>+</button>
                                </td>
                                <td>₹ {item.mrp}</td>
                                <td>₹ {discountAmount.toFixed(2)}</td>
                                <td>₹ {total.toFixed(2)}</td>
                                <td>
                                  <button className="remove-btn" onClick={() => handleRemoveRow(index)}><i class="fa-solid fa-trash"></i></button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th colSpan="5">Total</th>
                            <th id='grand-total' colSpan="2">₹ {items2.reduce((sum, item) => sum + ((item.mrp - ((item.discount || 0) / 100) * item.mrp) * item.qty), 0).toFixed(2)}</th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>

                    <div className="bill-estimate-btn">
                      <div className="bill-payment-delete-btn">
                        <button onClick={handleCancelEstimate}>Reset</button>
                      </div>

                      <div className="bill-estimate-share-btn">
                        <button
                          className="popup-save"
                          onClick={handlePrint}
                        >
                          Print
                        </button>
                        <button
                          className="popup-save"
                          onClick={handleEmailSend}
                        >
                          Email
                        </button>
                        <button
                          className="popup-save"
                          onClick={handelEstimateHistory}
                        >
                          History

                        </button>
                        <button
                          className="popup-save"
                          onClick={handleSave}
                        >
                          Save
                        </button>
                      </div>

                    </div>
                  </div>
                </div>

              )}
              {estimateHistory && (
                <div className="bill-popup-overlay">
                  <div className="bill-history-content">
                    <button className="bill-popup-close" onClick={() => setEstimateHistory(false)}>
                      <i className="fa-solid fa-x"></i>
                    </button>

                    <div className="bill-estimate-history-head">
                      <p>Name</p>
                      <p>Amount</p>
                      <p>Action</p>
                    </div>

                    <div className="bill-estimate-history-list-main">
                      {savedBills.length > 0 ? (
                        savedBills.map((bill, index) => (
                          <div key={index} className="bill-estimate-history-list">
                            <p>{bill.customer.email || "Unknown"}</p>
                            <p>₹ {bill.total}</p>
                            <div className="bill-estimate-history-list-btn">
                              <button onClick={() => handleViewBill(bill)}>View</button>
                              <i className="fa-solid fa-trash-can" onClick={() => handleDeleteBill(index)}></i>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>No saved bills</p>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {/* .............................................................................. History ..................................................................... */}
              <div className="bill-payment-button-box" onClick={handleHistory}>
                <p>History</p>
              </div>
              {showHistory && (
                <div className="bill-popup-overlay">
                  <div className="bill-history-popup-content">
                    <button className="bill-popup-close" onClick={handleCloseHistory}>
                      <i className="fa-solid fa-x"></i>
                    </button>
                    <div className="bill-history-search">
                      <div className="bill-estimate-model-search">
                        <i className="fa-solid fa-magnifying-glass"></i>
                        <input
                          type="search"
                          placeholder="Search...."

                        />

                      </div>
                    </div>
                    <div className="bill-history-table">
                      {loading ? (
                        <p>Loading...</p>
                      ) : (
                        <DataTable columns={his} data={historydata} fixedHeader pagination />
                      )}

                    </div>
                  </div>
                </div>
              )}
              {selectedBill && (
                <div className="bill-popup-overlay">
                  {/* {groupItemsHistory()} */}
                  <div className="bill-details-popup-content">
                    <button className="bill-popup-close" onClick={() => setSelectedBill(null)}>
                      <i className="fa-solid fa-x"></i>
                    </button>
                    <div className="bill-details-popup-content-main">
                      <div className="bill-details-customer-details">
                        <div className="bill-details-customer-bill-address">
                          <h3>Bill to :</h3>
                          <p>{selectedBill.customer_name}</p>
                          <p>{selectedBill.billing_address}</p>
                          <p>Contact : {selectedBill.phone}</p>
                          <p>GSTIN : {selectedBill.gstin}</p>
                          <div className="bill-details-customer-invoice">
                            <p><strong>Invoice No : </strong>{selectedBill.receipt_no}</p>
                          </div>
                        </div>
                        <div className="bill-details-customer-shipp-address">
                          <h3>Ship to :</h3>
                          <p>{selectedBill.shipping_address}</p>
                          <p>Contact : {selectedBill.phone}</p>
                          <p></p>
                          <p></p>
                          <div className="bill-details-customer-invoice">
                            <p><strong>Date : </strong>{formattedDate}</p>
                          </div>
                        </div>
                      </div>
                      <table>
                        <thead>
                          <tr>
                            <th>Serial No</th>
                            <th>Model</th>
                            <th>Qty</th>
                            <th>MRP</th>
                            {/* <th>Retail Price</th> */}
                            <th>Discount</th>
                            <th>Taxable Value</th>
                            <th>Tax</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* {console.log("historyyyyy",HistoryItems)} */}

                          {HistoryItems.map((group, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{group.model}</td>
                              <td>{group.qty}</td>
                              <td>{group.total_mrp}</td>
                              <td>{group.total_discount}</td>
                              <td>{group.taxable_value}</td>
                              <td>{group.total_tax}</td>
                              <td>{group.total_final_price}</td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th colSpan="5">Total</th>
                            {/* <th>₹ {items.reduce((sum, item) => sum + (item.discount || 0) * item.qty, 0).toFixed(2)}</th> */}
                            {/* Total MRP - Total Discount */}
                            <th>₹ {HistoryItems.reduce((sum, item) => sum + (item.total_mrp - item.total_discount), 0).toFixed(2)}</th>

                            {/* Total Tax (CGST + SGST + IGST) */}
                            <th>₹ {HistoryItems.reduce((sum, item) => sum + item.total_tax, 0).toFixed(2)}</th>

                            {/* Final Total (Sum of total_final_price) */}
                            <th>₹ {HistoryItems.reduce((sum, item) => sum + item.total_final_price, 0).toFixed(2)}</th>
                          </tr>
                        </tfoot>
                      </table>
                      <div className="bill-history-payment-details">
                        <div className="bill-history-payment">
                          <p>Total Amount :</p>
                          <p>₹ {paymentDetails.total_amount}</p>
                        </div>
                        <div className="bill-history-payment">
                          <p>Paid Amount :</p>
                          <p>₹ {paymentDetails.paid_amount}</p>
                        </div>
                        <div className="bill-history-payment">
                          <p>Balance :</p>
                          <p>₹ {paymentDetails.balance}</p>
                        </div>
                        <div className="bill-history-payment-method">
                          <p>Payment Method :</p>
                          <div className="bill-payment-methods">
                            {paymentDetails.payments?.length > 0 ? (
                              paymentDetails.payments.map((payment, index) => (
                                <div key={index} className="bill-payment-method">
                                  <p>{payment.payment_method} : ₹ {payment.payment_amount}</p>
                                </div>
                              ))
                            ) : (
                              <p>N/A</p>
                            )}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              )}

              {/* ................................................................................ Return ...................................................................... */}
              <div className="bill-payment-button-box" onClick={handleInvoice}>
                <p>Return</p>
              </div>
              {showInvoice && (
                <div className="bill-popup-overlay">
                  <div className="bill-invoice-popup-content">
                    <button className="bill-popup-close" onClick={handleCloseInvoice}>
                      <i className="fa-solid fa-x"></i>
                    </button>

                    <div className="bill-return-scan-input">
                      <label htmlFor="barcode">Scan Barcode :</label>
                      <input
                        type="text"
                        id="barcode"
                        value={barcode}
                        onChange={handleBarcodeChange}
                        autoFocus // ✅ Keeps focus on input field
                      />
                    </div>
                    {/* {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>} */}

                    <div className="bill-return-table-main">
                      <table>
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>Model</th>
                            <th>Qty</th>
                            <th>MRP</th>
                            <th>Discount</th>
                            <th>Taxable Value</th>
                            <th>Tax</th>
                            <th>Total</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {billingItems.length > 0 ? (
                            billingItems.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.model}</td>
                                <td>{item.qty}</td>
                                <td>₹ {item.mrp}</td>
                                <td>₹ {(item.item_discount * item.qty).toFixed(2)}</td>
                                <td>₹ {(item.mrp * item.qty) - item.item_discount * item.qty}</td>
                                <td>₹ {((parseFloat(item.sgst) + parseFloat(item.cgst)) * item.qty).toFixed(1)}</td>
                                <td>
                                  ₹ {item.final_price}
                                </td>
                                <td>
                                  <button className='bill-return-row-delete' onClick={() => handleRemoveItem(item.serialNo)}><i class="fa-solid fa-trash"></i></button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              {/* <td colSpan="8" style={{ textAlign: "center" }}>No billing data available</td> */}
                            </tr>
                          )}
                        </tbody>

                        {/* ✅ Total row */}
                        <tfoot>
                          <tr>
                            <th colSpan="5">Total</th>
                            <th>
                              ₹ {billingItems.reduce((sum, item) =>
                                sum + ((parseFloat(item.mrp) * item.qty) - (parseFloat(item.item_discount) * item.qty)),
                                0).toFixed(2)}
                            </th>
                            <th>₹ {billingItems.reduce((sum, item) => sum + ((parseFloat(item.sgst) + parseFloat(item.cgst)) * item.qty), 0).toFixed(2)}</th>
                            <th>
                              ₹ {billingItems.reduce((sum, item) =>
                                sum + ((parseFloat(item.mrp) * item.qty) - (parseFloat(item.item_discount) * item.qty)
                                  + ((parseFloat(item.sgst) + parseFloat(item.cgst)) * item.qty)), 0).toFixed(2)}
                            </th>
                            <th></th>
                          </tr>
                        </tfoot>

                      </table>
                    </div>
                    <div className="bill-return-buttons">
                      <button className="popup-save" onClick={handleReturn} disabled={loading}>
                        {loading ? "Processing..." : "Return"}
                      </button>
                      {/* <button className="popup-save" >Print</button> */}
                      <button className="popup-save" onClick={handelReturnReset}>Reset</button>
                    </div>

                  </div>
                </div>
              )}
              {/* ................................................................................ Sale ........................................................................ */}
              <div className="bill-payment-button-box" onClick={handleSale}>
                <p>Total Sale</p>
              </div>
              {showSale && (
                <div className="bill-popup-overlay">
                  <div className="bill-popup-content">
                    <button className="bill-popup-close" onClick={handleCloseSale}>
                      <i className="fa-solid fa-x"></i>
                    </button>

                    <button
                      className="popup-save"
                      onClick={() => {
                        // console.log("Updated Data: ", editData);
                        handleCloseSale();
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              )}
              {/* ............................................................................ Customer ......................................................................... */}
              <div className="bill-payment-button-box" onClick={handleCustomer}>
                <p>customer A/C</p>
              </div>
              {showCustomer && (
                <div className="bill-popup-overlay">
                  <div className="bill-customer-popup-content">
                    <button className="bill-popup-close" onClick={handleCloseCustomer}>
                      <i className="fa-solid fa-x"></i>
                    </button>

                    <div className="bill-customer-details-main">
                      <div className="bill-customer-details-head">
                        <h3>{filteredData} Details</h3>
                        <div className="bill-customer-search-main">
                          <div className="bill-estimate-model-search">
                            <i className="fa-solid fa-magnifying-glass"></i>
                            <input
                              type="search"
                              placeholder="Search..."
                              value={search}
                              onChange={handleSearchChange} // Fixed search
                            />
                          </div>
                          <div style={{ position: 'relative' }}>
                            <i className="fa-solid fa-sliders" onClick={handleSlide} ></i>
                            {filterslide && (
                              <div className="customer-slide-menu show">
                                {['customers', 'online customers', 'dealers'].map((filter) => (
                                  <div
                                    key={filter}
                                    className="thing-slide-item"
                                    onClick={() => handleFilterChange(filter)}
                                  >
                                    <span>{filter}</span>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>

                      </div>
                      <DataTable columns={customercol} data={customerdata} fixedHeader pagination />

                      {cusbillpopup && (
                        <div className="bill-popup-overlay">
                          <div className="bill-cusbill-popup-content">
                            <button className="bill-popup-close" onClick={() => setCusBillPopup(false)}>
                              <i className="fa-solid fa-x"></i>
                            </button>
                            <div className="bill-customer-bill-search">
                              <div className="bill-estimate-model-search">
                                <i className="fa-solid fa-magnifying-glass"></i>
                                <input
                                  type="search"
                                  placeholder="Search...."
                                  value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                />
                              </div>
                            </div>

                            <div className="bill-customer-table">
                              {loading ? (
                                <p>Loading...</p>
                              ) : error ? (
                                <p>Error: {error}</p>
                              ) : (
                                <DataTable columns={customerBill} data={billingData} pagination fixedHeader />

                              )}
                            </div>
                            <div className="bill-customer-balance-pay">
                              <div className="bill-customer-balance-box">
                                <p>Total Amount: </p>
                                <p> ₹ {balanceamount.total_amount}</p>
                              </div>
                              <div className="bill-customer-balance-box">
                                <p>Paid Amount:</p>
                                <p>₹ {balanceamount.paid_amount}</p>
                              </div>
                              <div className="bill-customer-balance-box">
                                <p>Balance:</p>
                                <p>₹ {balanceamount.balance}</p>
                              </div>
                              <button onClick={() => setBalancePayPopup(true)}>Pay Balance</button>
                            </div>
                            {balancePayPopup && (
                              <div className="bill-popup-overlay">
                                <div className="bill-popup-content">
                                  <button className="bill-popup-close" onClick={() => setBalancePayPopup(false)}>
                                    <i className="fa-solid fa-x"></i>
                                  </button>
                                  <div className="bill-payment-main">
                                    <div className="bill-payment-calculate-main">
                                      <div className="bill-payment-calculate">
                                        <input type="number" value={balanceInputValue} onChange={(e) => setBalanceInputValue(e.target.value)} />
                                        <div className="bill-payment-calculate-btn-main">
                                          {[
                                            ["7", "8", "9"],
                                            ["4", "5", "6"],
                                            ["1", "2", "3"],
                                            ["0", ".", "C"],
                                          ].map((row, rowIndex) => (
                                            <div className="bill-payment-calculate-btn" key={rowIndex}>
                                              {row.map((btnValue) => (
                                                <input
                                                  key={btnValue}
                                                  type="button"
                                                  value={btnValue}
                                                  className={btnValue === "C" ? "clear" : ""}
                                                  onClick={() => handleBalanceButtonClick(btnValue)}
                                                />
                                              ))}
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                      <div className="bill-payment-method-main">
                                        <div className="bill-payment-method-box" onClick={() => handleBalancePaymentMethodClick("cash")}>
                                          <h2>CASH</h2>
                                        </div>
                                        <div className="bill-payment-method-box" onClick={() => handleBalancePaymentMethodClick("bank")}>
                                          <h2>BANK</h2>
                                        </div>
                                        <div className="bill-payment-method-box" onClick={() => handleBalancePaymentMethodClick("online")}>
                                          <h2>GOOGLE PAY</h2>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="bill-payment-method-table-main">
                                      <div className="bill-payment-table-div">
                                        <table>
                                          <thead>
                                            <tr>
                                              <th>Description</th>
                                              <th>Amount</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {/* {console.log("paymenttt", paymentEntries)} */}

                                            {paymentEntries.map((entry, index) => (
                                              <tr key={index}>
                                                <td>{entry.method}</td>
                                                <td>₹ {entry.amount.toFixed(2)}</td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                      <div className="bill-payment-amount-calculate">
                                        <div className="bill-payment-invoice-value">
                                          <p>Balance Value :</p>
                                          <div className="bill-payment-amount-box">
                                            <span>₹ {balanceamount.balance || "0.00"}</span>
                                          </div>
                                        </div>

                                        {/* Collected Amount */}
                                        <div className="bill-payment-invoice-value">
                                          <p>Collected :</p>
                                          <div className="bill-payment-amount-box-1">
                                            <p>₹ {balancecollectedAmount}</p>
                                          </div>
                                        </div>

                                        <div className="bill-payment-invoice-value">
                                          <p>Balance :</p>
                                          <div className="bill-payment-amount-box-2">
                                            <p>
                                              ₹ {balance}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="bill-payment-save-buttons">
                                    <button onClick={handleBalancePayment} disabled={loading}>
                                      {loading ? "Processing..." : "Accept"}
                                    </button>
                                    <button onClick={handleBalanceCancel} >Cancel</button>
                                    <button onClick={() => setPaymentEntries([])} >Reset</button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      {customerBillPopup && (
                        <div className="bill-popup-overlay">
                          <div className="bill-details-popup-content">
                            <button className="bill-popup-close" onClick={() => setCustomerBillPopup(false)}>
                              <i className="fa-solid fa-x"></i>
                            </button>
                            <div className="bill-details-popup-content-main">
                              <div className="bill-details-customer-details">
                                <div className="bill-details-customer-bill-address">
                                  {/* {console.log("billingDatasssssss",billingData)} */}

                                  <h3>Bill to:</h3>
                                  <p>{customerSelectedBill.entity_name}</p>
                                  <p>{customerSelectedBill.billing_address}</p>
                                  <p>Contact: {customerSelectedBill.phone}</p>
                                  <p>GSTIN: {customerSelectedBill.gstin || "N/A"}</p>
                                  <div className="bill-details-customer-invoice">
                                    <p>
                                      <strong>Invoice No:</strong> {customerSelectedBill.receipt_no}
                                    </p>
                                  </div>
                                </div>
                                <div className="bill-details-customer-shipp-address">
                                  <h3>Ship to:</h3>
                                  <p>{customerSelectedBill.shipping_address}</p>
                                  <p>Contact: {customerSelectedBill.phone}</p>
                                  <div className="bill-details-customer-invoice">
                                    <p>
                                      <strong>Date:</strong> {formattedDate}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              {/* Table for Billing Items */}
                              <table>
                                <thead>
                                  <tr>
                                    <th>Serial No</th>
                                    <th>Model</th>
                                    <th>Qty</th>
                                    <th>MRP</th>
                                    <th>Discount</th>
                                    <th>Taxable Value</th>
                                    <th>Tax</th>
                                    <th>Total</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {groupedItemsArray.map((item, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{item.model}</td>
                                      <td>{item.quantity}</td>
                                      <td>₹ {parseFloat(item.mrp).toFixed(2)}</td>
                                      <td>₹ {parseFloat(item.item_discount).toFixed(2)}</td>
                                      <td>₹ {(parseFloat(item.mrp) - parseFloat(item.item_discount)).toFixed(2)}</td>
                                      <td>₹ {parseFloat(item.cgst + item.sgst + item.igst).toFixed(2)}</td>
                                      <td>₹ {parseFloat(item.final_price).toFixed(2)}</td>
                                    </tr>
                                  ))}
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <th colSpan="3">Total</th>
                                    <th>₹ {groupedItemsArray.reduce((sum, item) => sum + parseFloat(item.mrp), 0).toFixed(2)}</th>
                                    <th>₹ {groupedItemsArray.reduce((sum, item) => sum + parseFloat(item.item_discount), 0).toFixed(2)}</th>
                                    <th>₹ {groupedItemsArray.reduce((sum, item) => sum + (parseFloat(item.mrp) - parseFloat(item.item_discount)), 0).toFixed(2)}</th>
                                    <th>₹ {groupedItemsArray.reduce((sum, item) => sum + parseFloat(item.cgst + item.sgst + item.igst), 0).toFixed(2)}</th>
                                    <th>₹ {groupedItemsArray.reduce((sum, item) => sum + parseFloat(item.final_price), 0).toFixed(2)}</th>
                                  </tr>
                                </tfoot>
                              </table>
                              {/* <div className="bill-history-payment-details">
                                
                              </div>   */}
                            </div>
                          </div>
                        </div>
                      )}

                    </div>
                  </div>
                </div>
              )}
              {/* ............................................................................. Closing ........................................................................ */}
              <div className="bill-payment-button-box" onClick={() => setClosingPopup(true)}>
                <p>Closing</p>
                {closingPopup && (
                  <div className="bill-popup-overlay">
                    <div className="bill-clos-popup-content">
                      <h3>Are you sure you want to close the session?</h3>
                      <div className="bill-clos-popup-buttons">
                        <button onClick={closeSession} disabled={loading}>
                          {loading ? "Closing..." : "Yes, Close"}
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent event bubbling
                            // console.log("Closing popup"); // Debugging: Check if it's triggered
                            setClosingPopup(false);
                            
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Bill